import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth2Service } from './auth2.service';

/**
 * Allows navigation when the user is logged in, or redirects to the login page
 * after storing the attempted URL so the user can be redirected back to it.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth2Service = inject(Auth2Service);
  if (auth2Service.isLoggedIn) {
    return true;
  }

  // Store the attempted URL for redirecting
  auth2Service.redirectUrl = state.url;

  // Redirect to the login page
  return inject(Router).createUrlTree(['/login']);
};
